// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"33":"ec3e8966","123":"00cfc49d","167":"7d1dc18c","444":"3afca4d8","575":"d0b0bcec"}[chunkId] + ".chunk.js";
};